import "./TextField.scss";
import NP from "../../NP";
import TextField from "./TextField";

export default class NumField extends TextField {

	private _Min: number;
	private _Max: number;
	private _IsNullable: boolean;
	private _SpinEdit: boolean;
	private _EnableSpinEdit: boolean;
	private _FractionCount: number;

	private _spinEdit: HTMLElement;
	private _spinUp: HTMLElement;
	private _spinDown: HTMLElement;

	constructor(settings: object)
	{
		super(settings);
		this._renderNumericLayout();
		this.setValue(this._Value);
	}

	_initFields(settings: object)
	{
		this._FractionCount = 0;
		this._Min = -Infinity;
		this._Max = Infinity;
		this._IsNullable = false;
		this._SpinEdit = false;
		super._initFields(settings);
	}

	_renderNumericLayout()
	{
		if (this._SpinEdit)
		{
			this._spinEdit = document.createElement("div");
			this._spinEdit.className = "text-field__spin-edit";

			this._spinUp = document.createElement("button");
			this._spinUp.className = `text-field__spin-edit__btn app-list-item__graphic ${NP.FontImages.spin_up}`;
			this._spinUp.addEventListener('click', () =>
			{
				this.setValue(this._Value + 1);
				this.onFieldChange();
			});
			this._spinUp.addEventListener('mousedown', () => this._spinUp.style.opacity = "0.5");
			this._spinUp.addEventListener('mouseup', () => this._spinUp.style.opacity = "1");

			this._spinDown = document.createElement("button");
			this._spinDown.className = `text-field__spin-edit__btn app-list-item__graphic ${NP.FontImages.spin_down}`;
			this._spinDown.addEventListener('click', () =>
			{
				this.setValue(this._Value - 1);
				this.onFieldChange();
			});
			this._spinDown.addEventListener('mousedown', () => this._spinDown.style.opacity = "0.5");
			this._spinDown.addEventListener('mouseup', () => this._spinDown.style.opacity = "1");

			this._spinEdit.appendChild(this._spinUp);
			this._spinEdit.appendChild(this._spinDown);
			this._inputContainer.appendChild(this._spinEdit);

			NP.addCssClass(this._input, 'text-field__input--spin-edit');

			this.setEnableSpinEdit(this._EnableEdit);
		}
	}

	setEnableSpinEdit(value: boolean)
	{
		this._EnableSpinEdit = !!value;
		if (this._spinEdit)
			this._spinEdit.style.pointerEvents = this._EnableEdit ? 'auto' : 'none'
	}

	setMin(value: number)
	{
		this._Min = value;
	}

	setMax(value: number)
	{
		this._Max = value;
	}

	_prepareStringValue()
	{
		if (NP._CurrentUser.getRegionalSettings().DecimalSeparator == ',')
			return (this._Value.toFixed(this._FractionCount) + "").replace('.', ',');
		else
			return this._Value;
	}

	onFieldChange()
	{
		this._Value = this._getNumeric(this._input.value);
		this._input.value = this._prepareStringValue();
		this.EvChanged.fire(this, {Value: this._Value});
	}

	getValue()
	{
		return this._Value;
	}

	isNull()
	{
		return this._input.value == ''
	}

	// @ts-ignore
	setValue(value: number)
	{
		if (value == undefined || value == null)
			value = this._Min == -Infinity ? 0 : this._Min;
		if (value <= this._Min)
			value = this._Min;
		if (value >= this._Max)
			value = this._Max;
		this._Value = value;
		this._input.value = this._prepareStringValue();
	}

	setNullValue()
	{
		this._input.value = '';
	}


	_getNumeric(content: string)
	{
		if (content == null || content == "")
		{
			if (this._IsNullable)
				return null;
			else
				return NP.isNumber(this._Min) ? Math.max(this._Min, 0) : '';
		}

		let regInfo = NP._CurrentUser.getRegionalSettings(),
			 ds = regInfo.DecimalSeparator || NP.getCurrentCulture().DecimalSeparator,
			 gs = regInfo.ThousandsSeparator || NP.getCurrentCulture().GroupSeparator,
			 gsRe = new RegExp("\\" + gs, "g");
		//content = this._suffAndPrefRemove(content);
		content = content.replace(ds, ".");
		content = content.replace(gsRe, "");

		while (isNaN(parseFloat(content)) && content.length)
			content = content.substr(1);
		if (!content.length)
			content = "0";
		let ret = this._FractionCount == 0 ? parseInt(content) : parseFloat(content);
		if (isNaN(ret))
		{
			return this._Min == -Infinity ? 0 : this._Min;
		}
		if (ret <= this._Min)
			ret = this._Min;
		if (ret >= this._Max)
			ret = this._Max;
		return ret;
	}
}